import { useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import getDatasetAdminConsoleUrl from 'api/Dataset/getDatasetAdminConsoleUrl';

export default function useDatasetOpenS3(datasetUri: string) {
    const { openAlert } = useAlert();

    const [loadingButton, setLoadingButton] = useState(false);
    const client = useClient();

    const goToS3Console = async () => {
        try {
            setLoadingButton(true);
            if (datasetUri) {
                const response = await client.query(
                    getDatasetAdminConsoleUrl(datasetUri),
                );
                if (!response.errors) {
                    window.open(
                        response.data.getDatasetAssumeRoleUrl,
                        '_blank',
                    );
                } else {
                    openAlert({
                        severity: 'alert',
                        message:
                            'Something went wrong... Could not access S3 console',
                    });
                }
            }
        } finally {
            setLoadingButton(false);
        }
    };

    return { loadingButton, goToS3Console };
}
